import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { StatsView } from "@/features/stats/components/stats-view";

export const statsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/stats",
  component: StatsView,
});
